import { GrowerAttachmentsField } from './attachments/grower-attachments-field'
import type { UseFormReturn } from 'react-hook-form'
import type { GrowerFormValues } from '@/lib/schemas/grower-schemas'
import type { AttachmentDraft } from './attachments/use-attachment-draft'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { m } from '@/lib/paraglide/messages'

type Props = {
    form: UseFormReturn<GrowerFormValues>
    readOnly?: boolean
    attachments: AttachmentDraft
}

/**
 * Section B — Thông tin hồ sơ: giấy tờ nhân thân của hộ (CCCD…) + tài khoản
 * ngân hàng.
 *
 * Giấy tờ ĐẤT cố ý KHÔNG nằm ở đây nữa: nó thuộc từng vùng trồng và sống trong
 * tab của vùng đó (`grower-areas-section.tsx`). Hộ nhiều vùng gộp chung một ô
 * thì không ai biết bìa đỏ nào của vùng nào.
 */
export function GrowerProfileSection({ form, readOnly, attachments }: Props) {
    const disabled = !!readOnly

    return (
        <div className="space-y-5">
            <div className="space-y-1.5">
                <Label>{m.grower_documents()}</Label>
                <GrowerAttachmentsField
                    draft={attachments}
                    readOnly={disabled}
                    label={m.grower_documents()}
                />
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="space-y-1.5">
                    <Label>{m.grower_bank_number()}</Label>
                    <Input
                        disabled={disabled}
                        {...form.register('bank_number')}
                    />
                </div>
                <div className="space-y-1.5">
                    <Label>{m.grower_bank_name()}</Label>
                    <Input
                        disabled={disabled}
                        {...form.register('bank_name')}
                    />
                </div>
                <div className="space-y-1.5 sm:col-span-2">
                    <Label>{m.grower_bank_account()}</Label>
                    <Input
                        disabled={disabled}
                        {...form.register('bank_account')}
                    />
                </div>
            </div>
        </div>
    )
}
